import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import { AuthProvider } from './contexts/AuthProvider';
import { AuthGuard } from './components/AuthGuard';
import { CallbackHandler } from './components/CallbackHandler';
import MainAppContent from './components/MainAppContent';
import { setSystemErrorHandler } from "./config/apiConfig";
import SystemUnavailable from "./components/SystemUnavailable";
import SessionExpired from "./components/SessionExpired";
import { SystemErrorProvider, useSystemError } from "./contexts/SystemErrorContext";
import Footer from "./Layout/Footer";

const AppContent = () => {
  const { isSystemUnavailable, setSystemUnavailable, setNetworkError } = useSystemError();

  useEffect(() => {
    setSystemErrorHandler((unavailable, error) => {
      setSystemUnavailable(unavailable);
      setNetworkError(error || null);
    });
  }, [setSystemUnavailable, setNetworkError]);

  if (isSystemUnavailable) {
    return <SystemUnavailable />;
  }

  return (
    <div 
      id="app-container"
      style={{
        display: 'grid',
        gridTemplateRows: 'auto 1fr auto',
        gridTemplateColumns: '100%',
        minHeight: '100vh',
        backgroundColor: '#F6F7FB'
      }}
    >
      <CallbackHandler>
        <Routes>
          {/* Session expired route - accessible without authentication */}
          <Route path="/session-expired" element={<SessionExpired />} />
          
          {/* Protected routes */}
          <Route
            path="/*"
            element={
              <AuthGuard>
                <MainAppContent />
              </AuthGuard>
            }
          />
        </Routes>
      </CallbackHandler>
      {/* Footer positioned at the bottom, after all content */}
      <Footer />
    </div>
  );
};

// Main application component with routing and authentication context
function App() {
  return (
    <SystemErrorProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </SystemErrorProvider>
  );
}

export default App;
